import React, { useContext } from "react";
import { GlobalDataContext } from "../../context/context";
import { ButtonContent } from "../global/boton/ButtonContent";
import comercialVideo from '../../assets/image/Javi Promo.mp4'

function HeroSection({ Img1, Img2, Img3, Img4 }) {
  const { rpdata } = useContext(GlobalDataContext);

  const bgslide = [
    Img1,
    Img2,
    Img3,
    Img4
  ]
  return (
    <>
      <div className="pic-wrapper">

        {
          bgslide.map((img, index) => {
            return (
              <figure
                key={index}
                className={`pic-${index + 1}`}
                style={{ background: `url("${img}")` }}
              ></figure>
            )
          })
        }

        <div className="z-10 relative flex flex-wrap justify-center items-center text-center w-full mx-auto md:h-[110vh] h-[150vh] px-6">
          <div className="md:w-1/2 w-full h-[600px] md:h-full pb-[5%] md:pb-[10%] md:pr- [40%] pr-0 flex flex-col justify-end items-center md:items-start">
            <h1 className="text-white text-center md:text-start">
              {rpdata?.dbSlogan?.[0].slogan}
            </h1>
            <p className="text-white text-center md:text-start">{rpdata?.dbValues?.[2].description}</p>
            <div className="flex justify-center md:block">
              <ButtonContent />
            </div>
          </div>
          <div className="ms:w-1/2 h-[100px] md:h-full pb-[50%] md:pb-[10%] pr-0 flex justify-center items-center">
            <iframe src={comercialVideo} className='w-[530px] h-[380px] mx-auto rounded-3xl relative top-[80px] md:top-[150px]' autoPlay frameBorder="0" allowFullScreen title="video" />
          </div>
        </div>
      </div>
    </>
  );
}

export default HeroSection;
